var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_7552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0015 9.88601C32.686 6.01879 40.2744 3.98815 47.9969 4.00005L48 4.00005C72.3012 4.00005 92 23.6988 92 48C92 52.3452 91.3702 56.5432 90.1969 60.5078C90.0012 61.1689 90.1828 61.8819 90.6522 62.3869C91.6564 63.4673 93.5539 63.2414 93.9782 61.8286C95.2933 57.4497 96 52.8074 96 48C96 21.4902 74.5111 0.00088346 48.0015 5.43594e-05C39.574 -0.012655 31.2931 2.20347 23.9984 6.42369C23.0424 6.97683 22.7157 8.2003 23.2688 9.15639C23.822 10.1125 25.0454 10.4391 26.0015 9.88601Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8287 93.9782C63.2414 93.5539 63.4673 91.6565 62.3869 90.6522C61.8819 90.1828 61.1689 90.0013 60.5078 90.1969C56.5432 91.3702 52.3452 92 48 92C38.537 92 29.7719 89.013 22.5961 83.9303C23.0222 77.8391 24.2479 73.0602 27.489 69.6996C30.8776 66.1859 36.8948 63.8 48 63.8C51.9771 63.8 55.3017 64.106 58.0866 64.6602C58.8413 64.8104 59.6157 64.5017 60.0821 63.8896C60.9314 62.7749 60.5028 61.0743 59.1303 60.7913C55.9467 60.1348 52.2592 59.8 48 59.8C36.4501 59.8 29.1043 62.2624 24.6098 66.9229C20.973 70.6939 19.4839 75.6252 18.8541 80.9636C9.74365 72.9022 4 61.1221 4 48C4 39.9841 6.1429 32.4673 9.88568 26.0021C10.4391 25.0461 10.1128 23.8226 9.15682 23.2692C8.20088 22.7158 6.97732 23.0421 6.42392 23.998C2.3375 31.0568 0 39.2627 0 48C0 74.5104 21.4896 96 48 96C52.8074 96 57.4497 95.2933 61.8287 93.9782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 18.4C39.2739 18.4 32.2 25.4739 32.2 34.2C32.2 42.9261 39.2739 50 48 50C56.7261 50 63.8 42.9261 63.8 34.2C63.8 25.4739 56.7261 18.4 48 18.4ZM36.2 34.2C36.2 27.683 41.483 22.4 48 22.4C54.5169 22.4 59.8 27.683 59.8 34.2C59.8 40.7169 54.5169 46 48 46C41.483 46 36.2 40.7169 36.2 34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 64C74 62.8954 74.8954 62 76 62C77.1046 62 78 62.8954 78 64V88C78 89.1046 77.1046 90 76 90C74.8954 90 74 89.1046 74 88V64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 78C62.8954 78 62 77.1046 62 76C62 74.8954 62.8954 74 64 74H88C89.1046 74 90 74.8954 90 76C90 77.1046 89.1046 78 88 78H64Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_7552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.1d396f20.svg";
export { ForwardRef as ReactComponent };